import { forwardRef } from 'react';
import { inputClass } from './twClasses';

const TwInput = forwardRef(function TwInput({ className = '', ...props }, ref) {
  return (
    <input
      ref={ref}
      className={className ? `${inputClass} ${className}` : inputClass}
      {...props}
    />
  );
});

export default TwInput;
